module.exports = __webpack_public_path__ + "static/media/thumbnail.154aacea.jpg";